import { getAuthHeader } from "../utils/header";
import ApiEndpoints from "./apiConfig";

export const urlSleevesRecent = ApiEndpoints.sleevesRecent;
export const urlSleeve = ApiEndpoints.sleeve;
export const urlSleeves = ApiEndpoints.sleeves;
export const urlSleevesByTag = ApiEndpoints.sleevesByTag;
export const urlSleevesByUser = ApiEndpoints.sleevesByUser;
export const urlPopularTags = ApiEndpoints.popularTags;
export const urlPopularSleeves = ApiEndpoints.popularSleeves;
export const urlMostCommentsSleeves = ApiEndpoints.mostCommentsSleeves;
export const urlRandomSleeve = ApiEndpoints.randomSleeve;
export const urlSleevesSearch = ApiEndpoints.sleevesSearch;
export const urlFavorites = "/favorite/list?entity=sleeve";

export const urlAddSleeve = ApiEndpoints.addSleeve;
export const urlEditSleeve = ApiEndpoints.editSleeve;
// /sleevery/edit/@postId:[0-9]+

//user-api.dreamchimney.com/favorite/list?entity=sleeve

export const getSleeve = (axios, id) => axios.get(`${urlSleeve}/${id}`);
export const getSleeves = (axios, page) => axios.get(`${urlSleeves}?page=${page}`);
export const getRandomSleeve = (axios) => axios.get(`${urlRandomSleeve}`);
export const getSleevesByTag = (axios, find, page) => axios.get(`${urlSleevesByTag}?find=${find}&page=${page}`);
export const getSleevesByUser = (axios, chimDir, page) => axios.get(`${urlSleevesByUser}/${chimDir}?page=${page}`);
export const getPopularTags = (axios) => axios.get(`${urlPopularTags}`);
export const getPopularSleeves = (axios) => axios.get(`${urlPopularSleeves}`);
export const getMostCommentsSleeves = (axios) => axios.get(`${urlMostCommentsSleeves}`);
export const getRecentSleeves = (axios) => axios.get(urlSleevesRecent);
export const getSleevesSearch = (axios, find, page) => axios.get(`${urlSleevesSearch}?find=${find}&page=${page}`);

export const getSleeveIsFavorite = (axios, sleeveId) => axios.get(`/favorite?entity=sleeve&entityId=${sleeveId}`, getAuthHeader());
export const setSleeveIsFavorite = (axios, sleeveId) => axios.post(`/favorite`, { entity: `sleeve`, entityId: sleeveId }, getAuthHeader());
export const getSleeveFavorites = (axios, page) => axios.get(`${urlFavorites}&page=${page}`, getAuthHeader());

export const addSleeve = (axios, payload) => axios.post(urlAddSleeve, payload, getAuthHeader());
export const editSleeve = (axios, sleeveId, payload) => axios.post(`${urlEditSleeve}/${sleeveId}`, payload, getAuthHeader());
